(function ($) {
  function interceptCartAddRequests() {
    if (window.__cpbDisclaimerFetchPatched) return;
    window.__cpbDisclaimerFetchPatched = true;

    const originalFetch = window.fetch;

    window.fetch = async function (input, init) {
      try {
        const url =
          typeof input === "string"
            ? input
            : input && typeof input.url === "string"
            ? input.url
            : "";

        if (url.includes("/cart/add.js") && init && init.body) {
          let bodyObject = null;

          try {
            bodyObject = JSON.parse(init.body);
          } catch (e) {}

          if (bodyObject) {
            const tags = await loadProductTagsFromShopify();
            const isDisclaimerProduct =
              Array.isArray(tags) && tags.includes("Disclaimer");

            if (isDisclaimerProduct && Array.isArray(bodyObject.items)) {
              bodyObject.items.forEach((item, index) => {
                if (!item.properties) item.properties = {};
                item.properties["Disclaimer"] =
                  "Accepted during product customization";
              });

              init.body = JSON.stringify(bodyObject);
            }
          }
        }
      } catch (e) {
        console.error("[CPB DISCLAIMER] fetch intercept error:", e);
      }

      return originalFetch.apply(this, arguments);
    };
  }
  interceptCartAddRequests();

  async function duscounts() {
    let showDesignerDiscounts;
    let showWholesaleDiscounts;
    let cartTotalPrice = 0;
    let buildTotalPrice = 0;
    try {
      showDesignerDiscounts = productTags.designer;
      showWholesaleDiscounts =
        productTags.wholesale && productTags.bundle === false;
    } catch (e) {
      return;
    }
    if (!!showDesignerDiscounts === false && !!showWholesaleDiscounts === false)
      return;
    const discountPriceContainers = [];
    $(".cpb-product-full-price").each(() => {
      discountPriceContainers.push(
        $('<div class="cpb-custom-discounted-price">')
      );
    });
    updateCartPrice();
    document.addEventListener("cpb-add-to-cart", updateCartPrice);
    updateBuildPrice();
    document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", updateBuildPrice);
    $(document).on("mousedown, click", ".cpb-quantity-button", () => {
      setTimeout(updateBuildPrice, 1000);
    });

    function getDesignerDiscountPercent() {
      return cartTotalPrice + buildTotalPrice * 0.8 >= 10000 ? 20 : 0;
    }
    function getFullDiscountPercent() {
      let wholesaleDiscountPercent =
        cartTotalPrice + buildTotalPrice * 0.6 >= 80000 ? 40 : 0;
      return Math.max(getDesignerDiscountPercent(), wholesaleDiscountPercent);
    }
    function onPriceChange() {
      recountDiscounts();
    }
    function recountDiscounts() {
      let discountPercent = 0;
      if (showWholesaleDiscounts) discountPercent = getFullDiscountPercent();
      else discountPercent = getDesignerDiscountPercent();
      const discountedPriceNumber =
        Math.round(
          buildTotalPrice - (buildTotalPrice / 100) * discountPercent
        ) / 100;
      $(".cpb-product-full-price").each(function (i) {
        discountPriceContainers[i].text("$" + discountedPriceNumber.toFixed(2));
        discountPriceContainers[i].toggleClass(
          "cpb-custom-has-discount",
          discountPercent > 0
        );
        const price = $(this);
        price.toggleClass(
          "cpb-custom-price-before-discount",
          discountPercent > 0
        );
        price.append(discountPriceContainers[i]);
      });
    }
    function updateBuildPrice() {
      const newPrice = CPB.getStore().getState().Product.price * 100;
      console.log("update build price", newPrice, buildTotalPrice);
      if (buildTotalPrice === newPrice) return;
      buildTotalPrice = newPrice;
      onPriceChange();
    }
    async function updateCartPrice() {
      const productsInCartResponse = await fetch("/cart.js");
      const productsInCart = await productsInCartResponse.json();
      cartTotalPrice = productsInCart.total_price;
      onPriceChange();
    }
  }

  const changeLoaderImage = {
    init() {
      setTimeout(this.changeLoaderImage, 60000);
      document.body.addEventListener(
        "CPB_ON_OPTIONS_UPDATE",
        () => {
          setTimeout(this.changeLoaderImage, 10000);
        },
        { once: true }
      );
      document
        .querySelector(".cpb-add-to-cart-button")
        ?.addEventListener("click", this.changeLoaderImage);
    },
    changeLoaderImage: (function () {
      let changed = false;
      return function () {
        if (changed) return;
        changed = true;
        const style = document.createElement("style");
        style.setAttribute("data-custom-added-by-cpb", "");
        const addToCartImageUrl =
          "https://cdn.shopify.com/s/files/1/0219/0619/4532/t/82/assets/adding_to_cart.gif?v=1662663880";
        style.innerText =
          ".cpb-loader-center::before {background-image: url(" +
          addToCartImageUrl +
          ")}";
        document.body.appendChild(style);
      };
    })(),
  };

  document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", init);
  document.addEventListener("cpb-add-to-cart", function (event) {
    const drawer = new theme.CartDrawer();
    drawer.open();
  });

  const saveImageUrl = "https://api.thecustomproductbuilder.com/imageUpload/";
  async function saveImage(fileData) {
    const splitted = fileData.split(";base64,");
    const imageType = splitted[0].replace("data:", "");
    const data = {
      shopId: CPB.getStore().getState().App.shop.id,
      "file[mimetype]": imageType,
      "file[buffer]": splitted[1],
      "file[originalname]":
        (Math.random() + 1).toString(36).substring(2) +
        (Math.random() + 1).toString(36).substring(2) +
        "." +
        imageType.split("/")[1],
    };
    return new Promise((res) => {
      $.post(saveImageUrl, data, (data) => res(data));
    });
  }
  function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
    if (uri.match(re)) {
      return uri.replace(re, "$1" + key + "=" + value + "$2");
    } else {
      var hash = "";
      if (uri.indexOf("#") !== -1) {
        hash = uri.replace(/.*#/, "#");
        uri = uri.replace(/#.*/, "");
      }

      var separator = uri.indexOf("?") !== -1 ? "&" : "?";
      return uri + separator + key + "=" + value + hash;
    }
  }
  function getViewImageURL(size, view) {
    if (typeof window.cpbImageStorage === "undefined") return;
    view = view || "front";
    size = size || 1000;
    var convaSize = $(".konvajs-content").width() || size;
    var newRatio = size / convaSize;
    var getDataURL = cpbImageStorage.views[view].getSnapshot(newRatio);
    return getDataURL;
  }

  function myRegistry(customAddToCart) {
    if (!!customAddToCart === false) return;
    if (!!window.MyRegistrySDK === false) return;
    const addToCart = $(".cpb-add-to-cart-button").last();
    const registryBtn = $(
      '<button type="button" class="cpbc-my-registry-btn">Add To Registry</button>'
    ).on("click", () => {
      customAddToCart.setCartFunction(async (data) => {
        const item = data.items[0];
        const configId = item.properties._configId;
        const url = updateQueryStringParameter(
          window.location.href,
          "configid",
          configId
        );
        const imageUrl = item.properties._image;
        const gift = {
          Title: CPB.getStore().getState().Product.name,
          ImageUrl: imageUrl,
          URL: url,
          Price: +CPB.getStore().getState().Product.price,
          Quantity: CPB.getStore().getState().Product.quantity,
        };
        const registry = new window.MyRegistrySDK(gift);
        registry.showPopup();
        customAddToCart.setDefaultCartFunction();
      });
      addToCart.trigger("click");
    });
    addToCart.after(registryBtn);
    new MutationObserver(() => {
      if (!document.getElementById("myregistry_embed_view"))
        return console.log("stoped"); // added to make mobile menu work and finish appearing animation
      if (document.documentElement.classList.contains("js-drawer-closing")) {
        document.documentElement.classList.remove("js-drawer-closing");
      }
      if (document.documentElement.classList.contains("js-drawer-open")) {
        document.documentElement.classList.remove("js-drawer-open");
        document.documentElement.classList.remove("lock-scroll");
      }
    }).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  function getMetaValue(metafields, keys) {
    if (!Array.isArray(metafields) || metafields.length === 0) return null;

    for (const { namespace, key } of keys) {
      const mf = metafields.find((m) => {
        const mk = (m?.key ?? m?.name ?? "").toString();
        const ns = (m?.namespace ?? "").toString();
        if (namespace && ns !== namespace) return false;
        return mk === key;
      });

      if (mf) return mf.value ?? mf.val ?? mf.data ?? null;
    }
    return null;
  }

  const PJSteps = (() => {
    const TARGET_NAME =
      "Branded Glass Soap Bottle With Logo | Signature Collection-Copy";
    const INIT_FLAG = "__pjStepsInited";
    const EVENTS_BOUND_FLAG = "__pjStepsEventsBound";

    const STEP_META_KEYS = [
      { namespace: "custom", key: "stepKey" },
      { namespace: "cpb", key: "stepKey" },
      { namespace: "", key: "stepKey" },
    ];
    const STEP_ORDER_META_KEYS = [
      { namespace: "custom", key: "stepOrder" },
      { namespace: "cpb", key: "stepOrder" },
      { namespace: "", key: "stepOrder" },
    ];
    const STEP_LABEL_META_KEYS = [
      { namespace: "custom", key: "stepLabel" },
      { namespace: "cpb", key: "stepLabel" },
      { namespace: "", key: "stepLabel" },
    ];
    const ICON_META_KEYS = [
      { namespace: "custom", key: "custom-icon-svg" },
      { namespace: "cpb", key: "custom-icon-svg" },
      { namespace: "", key: "custom-icon-svg" },
    ];

    const SUMMARY_STEP = {
      key: "summary",
      label: "Add to cart",
      order: 9999,
      iconUrl:
        "https://cdn.shopify.com/s/files/1/0219/0619/4532/files/cartSvg.png?v=1776199565",
    };

    let state = null;
    let root = null;
    let categoriesContainer = null;
    let observer = null;

    function log(...args) {
      console.log("[PJ]", ...args);
    }

    function normalizeText(s) {
      return (s || "")
        .replace(/\u00A0/g, " ")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
    }

    function escapeHtml(s) {
      return String(s)
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#039;");
    }

    function escapeAttr(s) {
      return escapeHtml(s).replaceAll(" ", "_");
    }

    function escapeUrlAttr(s) {
      return String(s)
        .replaceAll("&", "&amp;")
        .replaceAll('"', "&quot;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;");
    }

    function humanizeStepKey(key) {
      return String(key || "")
        .replace(/[_-]+/g, " ")
        .replace(/\b\w/g, (m) => m.toUpperCase());
    }

    function getProductName() {
      const st = CPB?.getStore?.().getState?.();
      return (st?.Product?.name || "").trim();
    }

    function isTargetProduct() {
      const name = getProductName();
      log("check name:", name);
      return name === TARGET_NAME;
    }

    function hasAnyStepMetafields() {
      const st = CPB?.getStore?.().getState?.();
      const cats = st?.Product?.panels?.[0]?.categories;
      if (!Array.isArray(cats)) return false;

      return cats.some((cat) => {
        const mfs = cat?.metafields;
        if (!Array.isArray(mfs)) return false;
        return !!getMetaValue(mfs, STEP_META_KEYS);
      });
    }

    function ensureFrameMounted() {
      const panels = root.querySelector(".cpb-panels-container") || root;
      const h1 = panels.querySelector("h1.cpb-product-title");
      if (!h1) return;

      if (panels.querySelector(".pj-frame")) return;

      const frame = document.createElement("div");
      frame.className = "pj-frame";

      let node = h1.nextSibling;
      const toMove = [];
      while (node) {
        const next = node.nextSibling;
        if (!(node.nodeType === 3 && !node.textContent.trim()))
          toMove.push(node);
        node = next;
      }

      panels.appendChild(frame);
      toMove.forEach((n) => frame.appendChild(n));
    }

    function getCurrentPriceText() {
      const el =
        root.querySelector('[data-testid="multycurrency-price"]') ||
        root.querySelector(".cpb-product-price") ||
        root.querySelector('[class*="price"]');
      return (el?.textContent || "").trim();
    }

    function updateStepsInfoUI() {
      const titleEl = root.querySelector(".pj-steps-title");
      const priceEl = root.querySelector(".pj-steps-price");
      if (!titleEl || !priceEl) return;

      const idx = getCurrentStepIndex();
      const keys = getStepKeysInOrder();
      const isSummary = state.currentStepKey === SUMMARY_STEP.key;

      const stepNum = idx >= 0 ? idx + 1 : 1;

      const stepObj = state.steps.find((s) => s.key === state.currentStepKey);
      const stepLabel = stepObj?.label || humanizeStepKey(state.currentStepKey);

      titleEl.textContent = `Step ${stepNum}: ${stepLabel}`;
      priceEl.textContent = getCurrentPriceText();
    }

    function ensureActionsDividerMounted() {
      const actions = document.querySelector(".cpb-product-actions");
      if (!actions) return;

      if (
        actions.previousElementSibling?.classList?.contains(
          "pj-actions-divider"
        )
      )
        return;

      const div = document.createElement("div");
      div.className = "pj-actions-divider";
      actions.parentElement.insertBefore(div, actions);
    }

    function init() {
      try {
        if (!hasAnyStepMetafields()) return;
        document.body.classList.add("pj-steps-enabled");
        if (window[INIT_FLAG]) return;
        window[INIT_FLAG] = true;

        console.log("init steps");
        mount();
      } catch (e) {
        console.error("[PJ] init error:", e);
      }
    }

    function mount() {
      root = document.querySelector("#product-builder");

      if (!root) return;

      categoriesContainer =
        root.querySelector(".cpb-panel-categories-container.col-tabs") ||
        root.querySelector(".cpb-panel-categories-container");

      if (!categoriesContainer) return;

      state = {
        steps: [],
        currentStepKey: null,

        stepsUnlocked: false,

        domById: new Map(),

        storeById: new Map(),

        stepMap: new Map(),

        categories: [],

        iconCache: new Map(),
      };

      ensureFrameMounted();
      ensureStepBarMounted();

      rebuildAndApply();

      observer = new MutationObserver(() => {
        rebuildAndApply();
      });
      observer.observe(categoriesContainer, { childList: true });

      bindEventsOnce();
      ensureActionsDividerMounted();

      let tries = 0;
      const navTimer = setInterval(() => {
        tries += 1;
        const ok = ensureNavButtonsMounted();
        if (ok || tries > 50) {
          clearInterval(navTimer);
          updateNavButtonsUI();
          updateActionsVisibility();
        }
      }, 100);
    }

    function ensureStepBarMounted() {
      if (root.querySelector(".pj-steps")) return;

      const bar = document.createElement("div");
      bar.className = "pj-steps";
      bar.innerHTML = `
              <div class="pj-steps-info">
                <div class="pj-steps-text">
                <div class="pj-steps-title"></div>
                <div class="pj-steps-sub"></div>
              </div>
              <div class="pj-steps-price"></div>
              </div>
              <div class="pj-steps-buttons"></div>
              `;

      bar.addEventListener("click", (e) => {
        const btn = e.target.closest("button[data-step-key]");
        if (!btn) return;
        setStep(btn.dataset.stepKey);
      });

      const wrapper = root.querySelector(".cpb-panel-wrapper");
      const fallback = root.querySelector(".cpb-panels-container") || root;
      const mountRoot = wrapper || fallback;

      let stepsImg = null;
      if (wrapper) {
        const imgs = Array.from(wrapper.querySelectorAll("img"));
        stepsImg =
          imgs.find((img) => (img.alt || "").toLowerCase().includes("step")) ||
          imgs.find((img) => (img.src || "").toLowerCase().includes("step")) ||
          null;
      }

      if (stepsImg && stepsImg.parentElement) {
        stepsImg.parentElement.insertBefore(bar, stepsImg);
      } else {
        mountRoot.prepend(bar);
      }
    }

    async function preloadStepIcons() {
      const urls = (state.steps || []).map((s) => s.iconUrl).filter(Boolean);

      const unique = Array.from(new Set(urls)).filter(
        (u) => !state.iconCache.has(u)
      );

      await Promise.all(
        unique.map(async (url) => {
          try {
            const res = await fetch(url, { cache: "force-cache" });
            const contentType = res.headers.get("content-type") || "";

            if (!contentType.includes("image/svg+xml")) {
              state.iconCache.set(url, null);
              return;
            }

            const txt = await res.text();

            let clean = txt
              .replace(/fill="(?!none)[^"]*"/gi, 'fill="currentColor"')
              .replace(/stroke="(?!none)[^"]*"/gi, 'stroke="currentColor"');

            state.iconCache.set(url, clean);
          } catch (e) {
            state.iconCache.set(url, null);
          }
        })
      );
    }

    function renderStepBar() {
      const buttonsRoot = root.querySelector(".pj-steps-buttons");
      if (!buttonsRoot) return;

      const steps = state.steps || [];
      buttonsRoot.innerHTML = steps
        .map((s, i) => {
          const url = s.iconUrl || "";
          const svg = url ? state.iconCache.get(url) : null;

          const iconHtml = svg
            ? `<span class="pj-step-icon pj-step-icon--svg">${svg}</span>`
            : url
            ? `<span class="pj-step-icon"><img src="${escapeUrlAttr(
                url
              )}" alt="" /></span>`
            : "";

          const numHtml = `<span class="pj-step-num">${i + 1}</span>`;

          const btnHtml = `
              <button type="button" data-step-key="${escapeAttr(s.key)}">
                ${numHtml}
                ${iconHtml}
                <span class="pj-step-label">${escapeHtml(s.label)}</span>
              </button>
            `;

          const arrowHtml =
            i < steps.length - 1 ? `<span class="pj-step-arrow">→</span>` : "";

          return btnHtml + arrowHtml;
        })
        .join("");

      updateStepButtonsUI();
      updateStepsInfoUI();
    }

    function getFirstNonSummaryStepKey() {
      const first = state.steps.find((s) => s.key !== SUMMARY_STEP.key);
      return first ? first.key : null;
    }

    function setStep(stepKey) {
      const firstKey = getFirstNonSummaryStepKey();

      if (!state.stepsUnlocked && stepKey !== firstKey) return;

      if (!state.stepMap.has(stepKey) && stepKey !== SUMMARY_STEP.key) return;

      state.currentStepKey = stepKey;
      applyStep();
    }

    function updateStepButtonsUI() {
      const bar = root.querySelector(".pj-steps");
      if (!bar) return;

      const firstKey = getFirstNonSummaryStepKey();

      bar.querySelectorAll("button[data-step-key]").forEach((btn) => {
        const key = btn.dataset.stepKey;

        btn.classList.toggle("is-active", key === state.currentStepKey);

        const lockedByBottle = !state.stepsUnlocked && key !== firstKey;

        const emptyNow = key !== firstKey && !isStepCurrentlyRenderable(key);

        const disabled = lockedByBottle || emptyNow;

        btn.classList.toggle("is-disabled", disabled);
        btn.disabled = disabled;
      });
    }

    function getStepKeysInOrder() {
      return (state.steps || []).map((s) => s.key);
    }

    function getCurrentStepIndex() {
      return getStepKeysInOrder().indexOf(state.currentStepKey);
    }

    function setStepByIndex(nextIndex) {
      const keys = getStepKeysInOrder();
      if (nextIndex < 0 || nextIndex >= keys.length) return;
      setStep(keys[nextIndex]);
    }

    function ensureNavButtonsMounted() {
      const actions = document.querySelector(".cpb-product-actions");
      if (!actions) return false;

      const firstRow = actions.querySelector(".row");
      if (!firstRow) return false;

      if (firstRow.querySelector(".pj-nav")) return true;

      const nav = document.createElement("div");
      nav.className = "pj-nav";
      nav.innerHTML = `
              <button type="button" class="cpb-actions-btn pj-back"><span>&lt; Back</span></button>
              <button type="button" class="cpb-actions-btn pj-next"><span>Next &gt;</span></button>
              `;

      firstRow.appendChild(nav);

      nav.querySelector(".pj-back").addEventListener("click", () => {
        const idx = getCurrentStepIndex();
        if (idx <= 0) return;

        const prev = getNextRenderableStepKey(idx, -1);
        if (!prev) return;

        setStep(prev.key);
      });

      nav.querySelector(".pj-next").addEventListener("click", () => {
        const idx = getCurrentStepIndex();
        const keys = getStepKeysInOrder();
        if (idx === -1 || idx >= keys.length - 1) return;

        if (!state.stepsUnlocked && idx === 0) return;

        const next = getNextRenderableStepKey(idx, 1);
        if (!next) return;

        setStep(next.key);
      });

      return true;
    }

    function updateNavButtonsUI() {
      const backBtn = document.querySelector(".pj-nav .pj-back");
      const nextBtn = document.querySelector(".pj-nav .pj-next");
      if (!backBtn || !nextBtn) return;

      const idx = getCurrentStepIndex();
      const keys = getStepKeysInOrder();
      const lastIdx = keys.length - 1;

      const backDisabled = idx <= 0;
      backBtn.disabled = backDisabled;
      backBtn.classList.toggle("is-disabled", backDisabled);

      let nextDisabled = idx < 0 || idx >= lastIdx;

      if (!state.stepsUnlocked && idx === 0) nextDisabled = true;

      const currentKey = state.currentStepKey;
      const currentIsComplete =
        currentKey === SUMMARY_STEP.key ? true : isStepComplete(currentKey);
      if (!currentIsComplete) nextDisabled = true;

      const nextRenderable = getNextRenderableStepKey(idx, 1);
      if (!nextRenderable) nextDisabled = true;

      nextBtn.disabled = nextDisabled;
      nextBtn.classList.toggle("is-disabled", nextDisabled);
    }

    function rebuildAndApply() {
      rebuildStoreMap();
      rebuildDomMap();
      buildStepsAndMapsFromStore();
      preloadStepIcons().then(() => {
        mountCustomLabelIntoSteps();
        renderStepBar();
        updateStepButtonsUI();
      });

      if (!state.currentStepKey) {
        state.currentStepKey = getFirstNonSummaryStepKey() || SUMMARY_STEP.key;
      } else {
        const valid =
          state.currentStepKey === SUMMARY_STEP.key ||
          state.stepMap.has(state.currentStepKey);
        if (!valid)
          state.currentStepKey =
            getFirstNonSummaryStepKey() || SUMMARY_STEP.key;
      }

      recomputeUnlock();
      applyStep();
      updateStepsInfoUI();
    }

    function rebuildStoreMap() {
      state.storeById = getStoreCategoriesById();
    }

    function rebuildDomMap() {
      const els = Array.from(
        categoriesContainer.querySelectorAll(".cpb-category")
      );

      const map = new Map();
      const list = [];

      for (const el of els) {
        const id = extractCategoryIdFromClass(el);
        if (!id) continue;

        map.set(id, el);

        const titleEl = el.querySelector(".cpb-category-title");
        const title = titleEl ? titleEl.textContent.trim() : "";

        list.push({ id, el, title });
      }

      state.domById = map;
      state.categories = list;
    }

    function buildStepsAndMapsFromStore() {
      const storeById = state.storeById;
      const stepsByKey = new Map();
      const stepMap = new Map();

      for (const cat of storeById.values()) {
        const metaStepKey = getMetaValue(cat?.metafields, STEP_META_KEYS);
        if (!metaStepKey) continue;

        const stepKey = String(metaStepKey).trim();

        const metaLabel = getMetaValue(cat?.metafields, STEP_LABEL_META_KEYS);
        const stepLabel = metaLabel
          ? String(metaLabel).trim()
          : humanizeStepKey(stepKey);

        const metaOrder = getMetaValue(cat?.metafields, STEP_ORDER_META_KEYS);
        const stepOrder = Number.isFinite(Number(metaOrder))
          ? Number(metaOrder)
          : 999;

        const iconUrl = getMetaValue(cat?.metafields, ICON_META_KEYS);

        if (!stepMap.has(stepKey)) stepMap.set(stepKey, new Set());
        stepMap.get(stepKey).add(cat.id);

        if (!stepsByKey.has(stepKey)) {
          stepsByKey.set(stepKey, {
            key: stepKey,
            label: stepLabel,
            order: stepOrder,
            iconUrl: iconUrl || "",
          });
        } else {
          const s = stepsByKey.get(stepKey);
          if (!s.iconUrl && iconUrl) s.iconUrl = iconUrl;
        }
      }

      const steps = Array.from(stepsByKey.values()).sort(
        (a, b) => a.order - b.order
      );
      steps.push({ ...SUMMARY_STEP });

      state.steps = steps;
      state.stepMap = stepMap;
    }

    function updateActionsVisibility() {
      const actions = document.querySelector(".cpb-product-actions");
      if (!actions) return;

      const isSummary = state.currentStepKey === SUMMARY_STEP.key;

      const rows = Array.from(actions.querySelectorAll(":scope > .row"));
      rows.forEach((row, i) => {
        if (i === 0) {
          row.style.removeProperty("display");
        } else {
          if (isSummary) row.style.removeProperty("display");
          else row.style.display = "none";
        }
      });

      const qty = actions.querySelector(".cpb-quantity");
      if (qty) {
        if (isSummary) qty.style.removeProperty("display");
        else qty.style.display = "none";
      }

      const qtyWrap =
        actions.querySelector(".cpb-quantity-container") ||
        actions.querySelector('[class*="quantity"]');
      if (qtyWrap && qtyWrap !== qty) {
        qtyWrap.style.display = isSummary ? "" : "none";
      }
    }

    function applyStep() {
      updateStepButtonsUI();
      updateNavButtonsUI();

      ensureSummaryMounted();

      const summary = root.querySelector(".pj-summary");

      updateActionsVisibility();

      if (state.currentStepKey === SUMMARY_STEP.key) {
        state.categories.forEach((c) => (c.el.style.display = "none"));

        if (summary) {
          renderSummary();
          summary.style.display = "";
        }
        updateStepsInfoUI();
        return;
      }

      if (summary) summary.style.display = "none";

      const allowedIds = state.stepMap.get(state.currentStepKey) || new Set();
      state.categories.forEach((c) => {
        c.el.style.display = allowedIds.has(c.id) ? "" : "none";
      });

      updateStepsInfoUI();
    }

    function bindEventsOnce() {
      if (window[EVENTS_BOUND_FLAG]) return;
      window[EVENTS_BOUND_FLAG] = true;

      let refreshQueued = false;

      const runRefresh = () => {
        rebuildDomMap();
        recomputeUnlock();
        updateStepButtonsUI();
        updateNavButtonsUI();
        updateStepsInfoUI();

        if (state.currentStepKey === SUMMARY_STEP.key) renderSummary();
      };

      const scheduleRefresh = () => {
        if (refreshQueued) return;
        refreshQueued = true;

        requestAnimationFrame(() => {
          runRefresh();

          setTimeout(() => {
            runRefresh();

            setTimeout(() => {
              runRefresh();
              refreshQueued = false;
            }, 30);
          }, 0);
        });
      };

      document.body.addEventListener(
        "PRODUCT_BUILDER_OPTION_ACTIVATE",
        scheduleRefresh
      );
      categoriesContainer.addEventListener("change", scheduleRefresh, true);
      categoriesContainer.addEventListener("click", scheduleRefresh, true);

      document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", () => {
        rebuildAndApply();
      });
    }
    function isCategoryComplete(catId) {
      const el = state.domById.get(catId);
      if (!el) return false;

      const val = getActiveValueFromCategoryEl(el);
      return !!(val && val.trim());
    }
    function mountCustomLabelIntoSteps() {
      const sub = root.querySelector(".pj-steps-sub");
      if (!sub) return;

      const label = root.querySelector("p.cpb-custom-label");
      if (!label) return;

      if (label.parentElement !== sub) sub.appendChild(label);
    }
    function isStepComplete(stepKey) {
      const ids = state.stepMap.get(stepKey);
      if (!ids || ids.size === 0) return false;

      const domIds = Array.from(ids).filter((id) => state.domById.has(id));
      if (domIds.length === 0) return false;

      return domIds.every(isCategoryComplete);
    }
    function recomputeUnlock() {
      const firstKey = getFirstNonSummaryStepKey();
      state.stepsUnlocked = firstKey ? isStepComplete(firstKey) : true;
    }
    function extractCategoryIdFromClass(el) {
      for (const cls of el.classList) {
        if (cls.startsWith("cpb-category-") && cls !== "cpb-category") {
          return cls.replace("cpb-category-", "");
        }
      }
      for (const cls of el.classList) {
        if (
          cls.includes("--") &&
          cls.length > 10 &&
          !cls.startsWith("sc-") &&
          cls !== "category" &&
          cls !== "active"
        ) {
          return cls;
        }
      }
      return null;
    }
    function cleanTitle(raw) {
      let t = (raw || "").replace(/\u00A0/g, " ").trim();

      t = t.replace(/^select\s*/i, "");
      t = t.replace(/^choose\s*/i, "");
      t = t.replace(/^pick\s*/i, "");
      t = t.replace(/^select(?=[A-Z])/i, "");
      t = t.replace(/^choose(?=[A-Z])/i, "");
      t = t.replace(/^pick(?=[A-Z])/i, "");

      return t.trim();
    }

    function isStepCurrentlyRenderable(stepKey) {
      if (stepKey === SUMMARY_STEP.key) return true;

      const ids = state.stepMap.get(stepKey);
      if (!ids || ids.size === 0) return false;

      for (const id of ids) {
        if (state.domById.has(id)) return true;
      }
      return false;
    }

    function getNextRenderableStepKey(fromIndex, direction = 1) {
      const keys = getStepKeysInOrder();
      let i = fromIndex + direction;

      while (i >= 0 && i < keys.length) {
        const k = keys[i];
        if (isStepCurrentlyRenderable(k)) return { key: k, index: i };
        i += direction;
      }
      return null;
    }
    function getActiveValueFromCategoryEl(catEl) {
      if (!catEl) return "";

      const pickText = (el) =>
        (el?.textContent || "").replace(/\s+/g, " ").trim();

      const checked = catEl.querySelector(
        'input[type="radio"]:checked, input[type="checkbox"]:checked'
      );
      if (checked) {
        const label =
          checked.closest("label") ||
          (checked.id && catEl.querySelector(`label[for="${checked.id}"]`));
        const val = pickText(label) || pickText(checked) || checked.value;
        if (val) return val;
      }

      const ariaPicked = catEl.querySelector(
        '[aria-selected="true"], [aria-checked="true"], [aria-pressed="true"]'
      );
      if (ariaPicked) {
        const val = pickText(ariaPicked);
        if (val) return val;
      }

      const activeEl = catEl.querySelector(
        ".option.active, .active.option, .selected, .is-active, .active, [data-selected='true'], [data-active='true']"
      );
      if (activeEl) {
        const labelInside =
          activeEl.querySelector(".label, .option-label, span, button") ||
          activeEl;
        const val = pickText(labelInside);
        if (val) return val;
      }

      const input = catEl.querySelector("input, textarea");
      if (input && (input.value || "").trim()) return input.value.trim();

      return "";
    }

    function getCategoryByTitleIncludes(substr) {
      const needle = normalizeText(substr);
      return (
        state.categories.find((c) => normalizeText(c.title).includes(needle)) ||
        null
      );
    }

    function ensureSummaryMounted() {
      if (root.querySelector(".pj-summary")) return;

      const summary = document.createElement("div");
      summary.className = "pj-summary";
      summary.style.display = "none";

      categoriesContainer.prepend(summary);
    }

    function renderSummary() {
      const summary = root.querySelector(".pj-summary");
      if (!summary) return;

      const storeById = getStoreCategoriesById();

      const cards = [];

      for (const c of state.categories) {
        const tNorm = normalizeText(c.title);

        if (tNorm.includes("add a sleeve") || tNorm === "sleeve") continue;

        const storeCat = storeById.get(c.id);

        const stepKey = getMetaValue(storeCat?.metafields, STEP_META_KEYS);
        if (!stepKey) continue;

        if (String(stepKey).trim() === "upload_logo") continue;

        const value = getActiveValueFromCategoryEl(c.el);

        cards.push({
          title: cleanTitle(c.title) || "Option",
          value: value || "—",
          stepKey: String(stepKey).trim(),
          stepOrder: Number(
            getMetaValue(storeCat?.metafields, STEP_ORDER_META_KEYS) || 999
          ),
          catId: c.id,
        });
      }

      const addSleeveCat = state.categories.find((c) =>
        normalizeText(c.title).includes("add a sleeve")
      );
      const sleeveCats = state.categories.filter(
        (c) => normalizeText(c.title) === "sleeve"
      );

      if (addSleeveCat) {
        const addSleeveVal = normalizeText(
          getActiveValueFromCategoryEl(addSleeveCat.el)
        );
        const sleeveCatLive =
          sleeveCats.find((c) => getActiveValueFromCategoryEl(c.el)) ||
          sleeveCats[0] ||
          null;

        let sleeveValue = "—";

        if (addSleeveVal === "no") sleeveValue = "No";
        else if (addSleeveVal === "yes") {
          const picked = sleeveCatLive
            ? getActiveValueFromCategoryEl(sleeveCatLive.el)
            : "";
          sleeveValue = picked || "Yes";
        }

        const storeById = getStoreCategoriesById();
        const storeAddSleeve = storeById.get(addSleeveCat.id);

        const stepKey =
          getMetaValue(storeAddSleeve?.metafields, STEP_META_KEYS) ||
          "bottom_sleeve";
        const stepOrder = Number(
          getMetaValue(storeAddSleeve?.metafields, STEP_ORDER_META_KEYS) || 999
        );

        cards.push({
          title: "Sleeve",
          value: sleeveValue,
          stepKey: String(stepKey).trim(),
          stepOrder,
          catId: addSleeveCat.id,
        });
      }

      cards.sort(
        (a, b) => a.stepOrder - b.stepOrder || a.title.localeCompare(b.title)
      );

      summary.innerHTML = `
          <div class="pj-summary-grid">
            ${cards
              .map(
                (x) => `
                <div class="pj-summary-card">
                  <div class="pj-summary-card-head">
                    <div class="pj-summary-title">${escapeHtml(x.title)}</div>
                    <button type="button" class="pj-summary-edit" data-step-key="${escapeAttr(
                      x.stepKey
                    )}">Edit</button>
                  </div>
                  <div class="pj-summary-value">${escapeHtml(x.value)}</div>
                </div>
              `
              )
              .join("")}
          </div>
          `;

      const shouldScroll = false;
      summary.querySelectorAll(".pj-summary-edit").forEach((btn) => {
        btn.addEventListener("click", () => {
          e.preventDefault();
          e.stopPropagation();

          const stepKey = btn.dataset.stepKey;
          if (!stepKey) return;

          setStep(stepKey);

          if (shouldScroll) {
            categoriesContainer.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        });
      });
    }

    function getStoreCategoriesById() {
      const st = CPB?.getStore?.().getState?.();
      const arr = st?.Product?.panels?.[0]?.categories;
      const map = new Map();
      if (!Array.isArray(arr)) return map;

      for (const cat of arr) {
        if (cat?.id) map.set(cat.id, cat);
      }
      return map;
    }

    function debugReset() {
      window[INIT_FLAG] = false;
      window[EVENTS_BOUND_FLAG] = false;
      observer?.disconnect?.();
      observer = null;
      state = null;
      root = null;
      categoriesContainer = null;
      document.querySelector(".pj-steps")?.remove();
      document.querySelector(".pj-nav")?.remove();
      log("debugReset done");
    }

    return { init, debugReset };
  })();

  async function getCurrentProductHandle() {
    try {
      const pathname = window.location.pathname || "";
      const match = pathname.match(/\/products\/([^/?#]+)/);
      if (match && match[1]) return match[1];

      const cpbUrl =
        CPB?.getStore?.().getState?.()?.Product?.url ||
        CPB?.getStore?.().getState?.()?.Product?.handle;

      if (typeof cpbUrl === "string" && cpbUrl.length) {
        const cpbMatch = cpbUrl.match(/\/products\/([^/?#]+)/);
        if (cpbMatch && cpbMatch[1]) return cpbMatch[1];
        return cpbUrl;
      }

      return null;
    } catch (e) {
      console.error("[CPB DISCLAIMER] getCurrentProductHandle error:", e);
      return null;
    }
  }

  async function loadProductTagsFromShopify() {
    try {
      if (Array.isArray(window.productTagsRaw)) {
        return window.productTagsRaw;
      }

      const handle = await getCurrentProductHandle();

      if (!handle) return [];

      const res = await fetch(`/products/${handle}.js`, {
        credentials: "same-origin",
      });

      if (!res.ok) {
        console.error(
          "[CPB DISCLAIMER] product.js request failed:",
          res.status
        );
        return [];
      }

      const product = await res.json();

      let tags = product?.tags || [];

      if (typeof tags === "string") {
        tags = tags
          .split(",")
          .map((t) => t.trim())
          .filter(Boolean);
      }

      if (!Array.isArray(tags)) tags = [];

      window.productTagsRaw = tags;
      window.hasDisclaimerTag = tags.includes("Disclaimer");

      return tags;
    } catch (e) {
      console.error("[CPB DISCLAIMER] loadProductTagsFromShopify error:", e);
      return [];
    }
  }

  async function productHasDisclaimerTag() {
    try {
      const tags = await loadProductTagsFromShopify();
      const result = Array.isArray(tags) && tags.includes("Disclaimer");
      return result;
    } catch (e) {
      console.error("[CPB DISCLAIMER] productHasDisclaimerTag error:", e);
      return false;
    }
  }

  class CustomAddToCart {
    constructor() {
      const that = this;
      this.setDefaultCartFunction();
      if (!!window._cpb.settings === false) window._cpb.settings = {};
      window._cpb.settings.addToCartOverride = async (data) => {
        await that.addToCartFunction(data);
      };
    }
    setCartFunction(func) {
      this.addToCartFunction = func;
    }

    setDefaultCartFunction() {
      this.addToCartFunction = async (data) => {
        const hasDisclaimer = await productHasDisclaimerTag();

        if (hasDisclaimer && data?.items?.length) {
          data.items.forEach((item, index) => {
            if (!item.properties) item.properties = {};
            item.properties["Disclaimer"] =
              "Accepted during product customization";
          });
        } else {
          console.log("[CPB DISCLAIMER] property injection skipped");
        }

        fetch("/cart/add.js", {
          headers: {
            "content-type": "application/json;charset=UTF-8",
          },
          body: JSON.stringify(data),
          method: "POST",
        })
          .then(async (res) => {
            const text = await res.text();
            if (data.redirect) location.href = "/cart";
          })
          .catch((err) => {
            console.error("[CPB DISCLAIMER] fetch error:", err);
          });
      };
    }
  }

  /**
   * Remove broken ARIA references (WCAG fix)
   * Some CPB elements contain aria-describedby pointing to non-existent IDs (e.g. TooltipContent2),
   * which causes "Broken ARIA reference" errors in accessibility audits (WAVE).
   * This function cleans such attributes safely.
   */
  function removeBrokenAriaReferences() {
    document.querySelectorAll("[aria-describedby]").forEach((el) => {
      const ids = el.getAttribute("aria-describedby").split(" ");

      const validIds = ids.filter((id) => document.getElementById(id));

      if (validIds.length === 0) {
        // remove completely if no valid references exist
        el.removeAttribute("aria-describedby");
      } else {
        // update attribute if only some IDs are invalid
        el.setAttribute("aria-describedby", validIds.join(" "));
      }
    });
  }

  /**
   * Observe DOM changes and auto-remove broken aria-describedby
   * Needed because CPB dynamically mounts components
   */
  function observeBrokenAria() {
    if (window.__pjBrokenAriaObserverInited) return;
    window.__pjBrokenAriaObserverInited = true;

    removeBrokenAriaReferences();

    const observer = new MutationObserver(() => {
      removeBrokenAriaReferences();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  const OPTION_FONT_FAMILY_META_KEYS = [
    { namespace: "", key: "custom-option-font-family" },
    { namespace: "custom", key: "custom-option-font-family" },
    { namespace: "cpb", key: "custom-option-font-family" },
  ];

  const OPTION_FONT_SIZE_META_KEYS = [
    { namespace: "", key: "custom-option-font-size" },
    { namespace: "custom", key: "custom-option-font-size" },
    { namespace: "cpb", key: "custom-option-font-size" },
  ];

  const OPTION_MARGIN_TOP_META_KEYS = [
    { namespace: "", key: "custom-option-margin-top" },
    { namespace: "custom", key: "custom-option-margin-top" },
    { namespace: "cpb", key: "custom-option-margin-top" },
  ];

  function normalizeCssLength(value) {
    if (value == null) return null;

    const v = String(value).trim();
    if (!v) return null;

    // 20 -> 20px, 1.25 -> 1.25px
    if (/^-?\d+(\.\d+)?$/.test(v)) return `${v}px`;

    // allow 20px, 1.2rem, 100%, etc.
    return v;
  }

  function getCategoryElementById(id) {
    return (
      document.querySelector(`[data-category-id="${id}"]`) ||
      document.querySelector(`.cpb-category-${id}`)
    );
  }

  function getCategoryStyleTargets(category) {
    if (!category) return [];

    const selectors = [
      ".cpb-category-title",
      ".cpb-category-title *",
      ".cpb-category-title__inner",
      ".cpb-category-title__inner *",
      ".cpb-category-desc",
      ".cpb-category-desc *",
      ".cpb-category-description",
      ".cpb-category-description *",
    ];

    return Array.from(category.querySelectorAll(selectors.join(",")));
  }

  function changeUIbasedOnMetaFields() {
    const state = CPB?.getStore?.().getState?.();
    const categories = state?.Product?.panels?.[0]?.categories || [];

    categories.forEach((cat) => {
      if (!cat?.id) return;

      const { id, metafields } = cat;

      const category = getCategoryElementById(id);
      if (!category) return;

      const fontFamily = getMetaValue(metafields, OPTION_FONT_FAMILY_META_KEYS);
      const fontSize = normalizeCssLength(
        getMetaValue(metafields, OPTION_FONT_SIZE_META_KEYS)
      );
      const marginTop = normalizeCssLength(
        getMetaValue(metafields, OPTION_MARGIN_TOP_META_KEYS)
      );

      if (marginTop) {
        category.style.setProperty("margin-top", marginTop, "important");
      }

      const targets = getCategoryStyleTargets(category);

      targets.forEach((node) => {
        if (fontFamily) {
          node.style.setProperty("font-family", fontFamily, "important");
        }

        if (fontSize) {
          node.style.setProperty("font-size", fontSize, "important");
        }
      });
    });
  }

  function initCategoryMetaStyles() {
    if (window.__pjCategoryMetaStylesInited) return;
    window.__pjCategoryMetaStylesInited = true;

    let rafId = null;

    const scheduleApply = () => {
      if (rafId) cancelAnimationFrame(rafId);

      rafId = requestAnimationFrame(() => {
        changeUIbasedOnMetaFields();

        setTimeout(changeUIbasedOnMetaFields, 300);
        setTimeout(changeUIbasedOnMetaFields, 1000);
      });
    };

    scheduleApply();

    document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", scheduleApply);
    document.body.addEventListener(
      "PRODUCT_BUILDER_OPTION_ACTIVATE",
      scheduleApply
    );

    const root = document.querySelector("#product-builder");

    if (root) {
      new MutationObserver(scheduleApply).observe(root, {
        childList: true,
        subtree: true,
      });
    }
  }

  const CHOICE_LABEL_TEXT_META_KEYS = [
    { namespace: "", key: "custom-choice-label-text" },
    { namespace: "custom", key: "custom-choice-label-text" },
    { namespace: "cpb", key: "custom-choice-label-text" },
  ];

  const CHOICE_LABEL_COLOR_META_KEYS = [
    { namespace: "", key: "custom-choice-label-color" },
    { namespace: "custom", key: "custom-choice-label-color" },
    { namespace: "cpb", key: "custom-choice-label-color" },
  ];

  const CHOICE_LABEL_ICON_META_KEYS = [
    { namespace: "", key: "custom-choice-label-icon" },
    { namespace: "custom", key: "custom-choice-label-icon" },
    { namespace: "cpb", key: "custom-choice-label-icon" },
  ];

  const CHOICE_POPUP_TEXT_META_KEYS = [
    { namespace: "", key: "custom-choice-popup-text" },
    { namespace: "custom", key: "custom-choice-popup-text" },
    { namespace: "cpb", key: "custom-choice-popup-text" },
  ];

  const CHOICE_POPUP_ICON_META_KEYS = [
    { namespace: "", key: "custom-choice-popup-icon" },
    { namespace: "custom", key: "custom-choice-popup-icon" },
    { namespace: "cpb", key: "custom-choice-popup-icon" },
  ];

  const CHOICE_BADGE_TEXT_META_KEYS = [
    { namespace: "", key: "custom-choice-badge-text" },
    { namespace: "custom", key: "custom-choice-badge-text" },
    { namespace: "cpb", key: "custom-choice-badge-text" },
  ];

  const CHOICE_BADGE_ICON_META_KEYS = [
    { namespace: "", key: "custom-choice-badge-icon" },
    { namespace: "custom", key: "custom-choice-badge-icon" },
    { namespace: "cpb", key: "custom-choice-badge-icon" },
  ];

  const CHOICE_BADGE_IMAGE_META_KEYS = [
    { namespace: "", key: "custom-choice-badge-image" },
    { namespace: "custom", key: "custom-choice-badge-image" },
    { namespace: "cpb", key: "custom-choice-badge-image" },
  ];

  const CHOICE_BADGE_COLOR_META_KEYS = [
    { namespace: "", key: "custom-choice-badge-color" },
    { namespace: "custom", key: "custom-choice-badge-color" },
    { namespace: "cpb", key: "custom-choice-badge-color" },
  ];

  const CHOICE_BADGE_BACKGROUND_META_KEYS = [
    { namespace: "", key: "custom-choice-badge-background-color" },
    { namespace: "custom", key: "custom-choice-badge-background-color" },
    { namespace: "cpb", key: "custom-choice-badge-background-color" },
    { namespace: "", key: "custom-choice-badge-bg-color" },
    { namespace: "custom", key: "custom-choice-badge-bg-color" },
    { namespace: "cpb", key: "custom-choice-badge-bg-color" },
  ];

  const CHOICE_BADGE_POSITION_META_KEYS = [
    { namespace: "", key: "custom-choice-badge-position" },
    { namespace: "custom", key: "custom-choice-badge-position" },
    { namespace: "cpb", key: "custom-choice-badge-position" },
  ];

  function pjEscapeHtml(value) {
    return String(value ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function pjEscapeSelectorAttr(value) {
    return String(value ?? "")
      .replace(/\\/g, "\\\\")
      .replace(/"/g, '\\"');
  }

  function isUrlValue(value) {
    return /^https?:\/\//i.test(String(value || "").trim());
  }

  function getChoiceLabelIconHtml(iconValue) {
    const icon = String(iconValue || "").trim();
    if (!icon) return "";

    const normalizedIcon = icon.toLowerCase();

    const iconMap = {
      star: "★",
      heart: "♡",
      check: "✓",
      sparkle: "✦",
      diamond: "◆",
      circle: "●",
      dot: "•",
      plus: "+",
    };

    if (isUrlValue(icon)) {
      return `
        <span class="pj-choice-label__icon pj-choice-label__icon--image" aria-hidden="true">
          <img src="${pjEscapeHtml(icon)}" alt="" loading="lazy">
        </span>
      `;
    }

    const iconContent = iconMap[normalizedIcon] || icon;

    return `
      <span class="pj-choice-label__icon pj-choice-label__icon--text" aria-hidden="true">
        ${pjEscapeHtml(iconContent)}
      </span>
    `;
  }

  function getChoiceLabelData(option) {
    const text = getMetaValue(option?.metafields, CHOICE_LABEL_TEXT_META_KEYS);
    const color = getMetaValue(
      option?.metafields,
      CHOICE_LABEL_COLOR_META_KEYS
    );
    const icon = getMetaValue(option?.metafields, CHOICE_LABEL_ICON_META_KEYS);

    return {
      text: String(text || "").trim(),
      color: String(color || "").trim(),
      icon: String(icon || "").trim(),
    };
  }

  function getChoiceOptionElement(optionId) {
    if (!optionId) return null;

    return document.querySelector(
      `#product-builder .cpb-option[data-option-id="${pjEscapeSelectorAttr(
        optionId
      )}"]`
    );
  }

  function setClassState(element, className, shouldHaveClass) {
    if (!element) return;

    if (shouldHaveClass) {
      if (!element.classList.contains(className)) {
        element.classList.add(className);
      }
    } else {
      if (element.classList.contains(className)) {
        element.classList.remove(className);
      }
    }
  }

  function isOwnChoiceLabelMutation(mutation) {
    const target = mutation.target;

    if (
      target?.nodeType === 1 &&
      typeof target.closest === "function" &&
      target.closest(".pj-choice-label")
    ) {
      return true;
    }

    const changedNodes = [
      ...Array.from(mutation.addedNodes || []),
      ...Array.from(mutation.removedNodes || []),
    ];

    if (!changedNodes.length) return false;

    return changedNodes.every((node) => {
      if (node.nodeType !== 1) return false;

      return (
        node.classList?.contains("pj-choice-label") ||
        (typeof node.closest === "function" && node.closest(".pj-choice-label"))
      );
    });
  }

  function getChoiceLabelElement(wrapper, optionEl) {
    if (!wrapper || !optionEl) return null;

    const directLabel = Array.from(wrapper.children).find((child) =>
      child.classList?.contains("pj-choice-label")
    );

    return directLabel || optionEl.querySelector(".pj-choice-label");
  }

  function cleanupChoiceLabelGroup(optionEl) {
    const group = optionEl.querySelector(".pj-choice-label-group");
    if (!group || !group.parentElement) return;

    const optionLabel = group.querySelector(".cpb-option-label");

    if (optionLabel) {
      group.parentElement.insertBefore(optionLabel, group);
    }

    if (!group.querySelector(".pj-choice-label")) {
      group.remove();
    }
  }

  function mountChoiceLabel(optionEl, labelData) {
    const wrapper = optionEl.closest(".option") || optionEl.parentElement;
    if (!wrapper) return null;

    let labelEl = getChoiceLabelElement(wrapper, optionEl);

    if (!labelData.text) {
      if (labelEl) labelEl.remove();

      cleanupChoiceLabelGroup(optionEl);

      setClassState(wrapper, "pj-choice-label-wrapper", false);
      setClassState(wrapper, "pj-choice-label-wrapper--outside", false);
      setClassState(wrapper, "pj-choice-label-wrapper--inside", false);

      return null;
    }

    setClassState(wrapper, "pj-choice-label-wrapper", true);
    setClassState(wrapper, "pj-choice-label-wrapper--outside", true);
    setClassState(wrapper, "pj-choice-label-wrapper--inside", false);

    if (!labelEl) {
      labelEl = document.createElement("div");
      labelEl.className = "pj-choice-label";
    }

    setClassState(labelEl, "pj-choice-label--outside", true);
    setClassState(labelEl, "pj-choice-label--inside", false);

    if (optionEl.nextElementSibling !== labelEl) {
      optionEl.insertAdjacentElement("afterend", labelEl);
    }

    cleanupChoiceLabelGroup(optionEl);

    const nextColor = labelData.color || "";
    const currentColor = labelEl.dataset.pjColor || "";

    if (currentColor !== nextColor) {
      labelEl.dataset.pjColor = nextColor;

      if (nextColor) {
        labelEl.style.setProperty("color", nextColor, "important");
      } else {
        labelEl.style.removeProperty("color");
      }
    }

    const nextText = labelData.text || "";
    const nextIcon = labelData.icon || "";

    const contentChanged =
      labelEl.dataset.pjText !== nextText ||
      labelEl.dataset.pjIcon !== nextIcon;

    if (contentChanged) {
      labelEl.dataset.pjText = nextText;
      labelEl.dataset.pjIcon = nextIcon;

      labelEl.innerHTML = `
        ${getChoiceLabelIconHtml(nextIcon)}
        <span class="pj-choice-label__text">${pjEscapeHtml(nextText)}</span>
      `;
    }

    return labelEl;
  }

  function applyChoiceLabels() {
    const categories =
      CPB?.getStore?.().getState?.()?.Product?.panels?.[0]?.categories || [];

    if (!Array.isArray(categories) || categories.length === 0) return;

    const containersWithLabels = new Set();

    categories.forEach((category) => {
      const options = category?.options || [];
      if (!Array.isArray(options) || options.length === 0) return;

      options.forEach((option) => {
        const labelData = getChoiceLabelData(option);
        const optionEl = getChoiceOptionElement(option?.id);

        if (!optionEl) return;

        mountChoiceLabel(optionEl, labelData);

        const container = optionEl.closest(".cpb-category-options-container");

        if (labelData.text && container) {
          containersWithLabels.add(container);
        }
      });
    });

    document
      .querySelectorAll("#product-builder .cpb-category-options-container")
      .forEach((container) => {
        setClassState(
          container,
          "pj-has-choice-labels",
          containersWithLabels.has(container)
        );
      });
  }

  function initChoiceLabels() {
    if (window.__pjChoiceLabelsInited) return;
    window.__pjChoiceLabelsInited = true;

    let rafId = null;
    let timeoutOne = null;
    let timeoutTwo = null;

    const scheduleApply = () => {
      if (rafId) cancelAnimationFrame(rafId);
      clearTimeout(timeoutOne);
      clearTimeout(timeoutTwo);

      rafId = requestAnimationFrame(() => {
        applyChoiceLabels();

        timeoutOne = setTimeout(applyChoiceLabels, 300);
        timeoutTwo = setTimeout(applyChoiceLabels, 1000);
      });
    };

    scheduleApply();

    document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", scheduleApply);
    document.body.addEventListener(
      "PRODUCT_BUILDER_OPTION_ACTIVATE",
      scheduleApply
    );

    const root = document.querySelector("#product-builder");

    if (root) {
      const observer = new MutationObserver((mutations) => {
        const onlyOwnLabelChanges = mutations.every(isOwnChoiceLabelMutation);

        if (onlyOwnLabelChanges) return;

        scheduleApply();
      });

      observer.observe(root, {
        childList: true,
        subtree: true,
      });

      window.__pjChoiceLabelsObserver = observer;
    }
  }

  function getChoicePopupData(option) {
    const text = getMetaValue(option?.metafields, CHOICE_POPUP_TEXT_META_KEYS);
    const icon = getMetaValue(option?.metafields, CHOICE_POPUP_ICON_META_KEYS);

    return {
      text: String(text || "").trim(),
      icon: String(icon || "").trim(),
    };
  }

  function isChoiceOptionActive(optionEl) {
    if (!optionEl) return false;

    return (
      optionEl.classList.contains("cpb-active") ||
      optionEl.getAttribute("aria-pressed") === "true" ||
      optionEl.getAttribute("aria-selected") === "true" ||
      optionEl.getAttribute("aria-checked") === "true" ||
      optionEl.dataset.selected === "true" ||
      optionEl.dataset.active === "true"
    );
  }

  function getChoicePopupContainer(optionEl) {
    const category = optionEl.closest(".cpb-category");
    if (!category) return null;

    const optionsContainer = optionEl.closest(
      ".cpb-category-options-container"
    );

    return {
      category,
      anchor:
        optionsContainer ||
        category.querySelector(".cpb-category-content") ||
        category,
    };
  }

  function getExistingChoicePopup(category) {
    if (!category) return null;

    return category.querySelector(".pj-choice-popup");
  }

  function getOrCreateChoicePopup(category, anchor) {
    let popup = getExistingChoicePopup(category);

    if (!popup) {
      popup = document.createElement("div");
      popup.className = "pj-choice-popup";
      anchor.insertAdjacentElement("afterend", popup);
    } else if (anchor && popup.previousElementSibling !== anchor) {
      anchor.insertAdjacentElement("afterend", popup);
    }

    return popup;
  }

  function removeChoicePopup(category) {
    getExistingChoicePopup(category)?.remove();
  }

  function renderChoicePopup(popup, optionId, popupData) {
    const nextText = popupData.text || "";
    const nextIcon = popupData.icon || "";

    const contentChanged =
      popup.dataset.pjOptionId !== optionId ||
      popup.dataset.pjText !== nextText ||
      popup.dataset.pjIcon !== nextIcon;

    if (!contentChanged) return;

    popup.dataset.pjOptionId = optionId;
    popup.dataset.pjText = nextText;
    popup.dataset.pjIcon = nextIcon;

    popup.innerHTML = `
      <div class="pj-choice-popup__content">
        ${getChoiceLabelIconHtml(nextIcon)}
        <span class="pj-choice-popup__text">${pjEscapeHtml(nextText)}</span>
      </div>
      <button type="button" class="pj-choice-popup__close" aria-label="Close">×</button>
    `;
  }

  function isOwnChoicePopupMutation(mutation) {
    const target = mutation.target;

    if (
      target?.nodeType === 1 &&
      typeof target.closest === "function" &&
      target.closest(".pj-choice-popup")
    ) {
      return true;
    }

    const changedNodes = [
      ...Array.from(mutation.addedNodes || []),
      ...Array.from(mutation.removedNodes || []),
    ];

    if (!changedNodes.length) return false;

    return changedNodes.every((node) => {
      if (node.nodeType !== 1) return false;

      return (
        node.classList?.contains("pj-choice-popup") ||
        (typeof node.closest === "function" && node.closest(".pj-choice-popup"))
      );
    });
  }

  function applyChoicePopups() {
    const categories =
      CPB?.getStore?.().getState?.()?.Product?.panels?.[0]?.categories || [];

    if (!Array.isArray(categories) || categories.length === 0) return;

    if (!window.__pjClosedChoicePopups) {
      window.__pjClosedChoicePopups = new Set();
    }

    const activeOptionIds = new Set();
    const categoriesWithPopup = new Set();

    categories.forEach((category) => {
      const options = category?.options || [];
      if (!Array.isArray(options) || options.length === 0) return;

      options.forEach((option) => {
        const optionId = option?.id;
        const optionEl = getChoiceOptionElement(optionId);

        if (!optionEl || !isChoiceOptionActive(optionEl)) return;

        activeOptionIds.add(optionId);

        const popupData = getChoicePopupData(option);
        if (!popupData.text) return;

        const popupMount = getChoicePopupContainer(optionEl);
        if (!popupMount?.category || !popupMount?.anchor) return;

        categoriesWithPopup.add(popupMount.category);

        if (window.__pjClosedChoicePopups.has(optionId)) {
          removeChoicePopup(popupMount.category);
          return;
        }

        const popup = getOrCreateChoicePopup(
          popupMount.category,
          popupMount.anchor
        );

        renderChoicePopup(popup, optionId, popupData);
      });
    });

    window.__pjClosedChoicePopups.forEach((optionId) => {
      if (!activeOptionIds.has(optionId)) {
        window.__pjClosedChoicePopups.delete(optionId);
      }
    });

    document
      .querySelectorAll("#product-builder .pj-choice-popup")
      .forEach((popup) => {
        const category = popup.closest(".cpb-category");

        if (!category || !categoriesWithPopup.has(category)) {
          popup.remove();
        }
      });
  }

  function initChoicePopups() {
    if (window.__pjChoicePopupsInited) return;
    window.__pjChoicePopupsInited = true;

    let rafId = null;
    let timeoutOne = null;
    let timeoutTwo = null;

    const scheduleApply = () => {
      if (rafId) cancelAnimationFrame(rafId);
      clearTimeout(timeoutOne);
      clearTimeout(timeoutTwo);

      rafId = requestAnimationFrame(() => {
        applyChoicePopups();

        timeoutOne = setTimeout(applyChoicePopups, 300);
        timeoutTwo = setTimeout(applyChoicePopups, 1000);
      });
    };

    document.addEventListener(
      "click",
      (event) => {
        const closeBtn = event.target.closest(".pj-choice-popup__close");

        if (closeBtn) {
          const popup = closeBtn.closest(".pj-choice-popup");
          const optionId = popup?.dataset?.pjOptionId;

          if (optionId) {
            if (!window.__pjClosedChoicePopups) {
              window.__pjClosedChoicePopups = new Set();
            }

            window.__pjClosedChoicePopups.add(optionId);
          }

          popup?.remove();

          event.preventDefault();
          event.stopPropagation();

          return;
        }

        if (event.target.closest("#product-builder .cpb-option")) {
          scheduleApply();
        }
      },
      true
    );

    document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", scheduleApply);
    document.body.addEventListener(
      "PRODUCT_BUILDER_OPTION_ACTIVATE",
      scheduleApply
    );

    scheduleApply();

    const root = document.querySelector("#product-builder");

    if (root) {
      const observer = new MutationObserver((mutations) => {
        const onlyOwnPopupChanges = mutations.every(isOwnChoicePopupMutation);

        if (onlyOwnPopupChanges) return;

        scheduleApply();
      });

      observer.observe(root, {
        childList: true,
        subtree: true,
      });

      window.__pjChoicePopupsObserver = observer;
    }
  }

  function normalizeChoiceBadgeIcon(value) {
    const icon = String(value || "").trim();

    if (/^(check|checkmark|tick|✓)$/i.test(icon)) {
      return "";
    }

    return icon;
  }

  function normalizeChoiceBadgePosition(value) {
    const position = String(value || "")
      .trim()
      .toLowerCase();

    const allowedPositions = [
      "top-left",
      "bottom-left",
      "bottom-right",
      "below",
    ];

    return allowedPositions.includes(position) ? position : "top-left";
  }

  function getChoiceBadgeData(option) {
    const text = getMetaValue(option?.metafields, CHOICE_BADGE_TEXT_META_KEYS);
    const icon = normalizeChoiceBadgeIcon(
      getMetaValue(option?.metafields, CHOICE_BADGE_ICON_META_KEYS)
    );
    const image = getMetaValue(
      option?.metafields,
      CHOICE_BADGE_IMAGE_META_KEYS
    );
    const color = getMetaValue(
      option?.metafields,
      CHOICE_BADGE_COLOR_META_KEYS
    );
    const background = getMetaValue(
      option?.metafields,
      CHOICE_BADGE_BACKGROUND_META_KEYS
    );
    const position = getMetaValue(
      option?.metafields,
      CHOICE_BADGE_POSITION_META_KEYS
    );

    return {
      text: String(text || "").trim(),
      icon: String(icon || "").trim(),
      image: String(image || "").trim(),
      color: String(color || "").trim(),
      background: String(background || "").trim(),
      position: normalizeChoiceBadgePosition(position),
    };
  }

  function choiceBadgeHasContent(badgeData) {
    return !!(badgeData.text || badgeData.icon || badgeData.image);
  }

  function getChoiceBadgeElement(wrapper, optionEl) {
    if (!wrapper || !optionEl) return null;

    const directWrapperBadge = Array.from(wrapper.children).find((child) =>
      child.classList?.contains("pj-choice-badge")
    );

    const directOptionBadge = Array.from(optionEl.children).find((child) =>
      child.classList?.contains("pj-choice-badge")
    );

    return directWrapperBadge || directOptionBadge || null;
  }

  function getChoiceBadgeIconHtml(iconValue, imageValue) {
    const image = String(imageValue || "").trim();
    const icon = String(iconValue || "").trim();

    if (image) {
      return `
        <span class="pj-choice-badge__icon pj-choice-badge__icon--image" aria-hidden="true">
          <img src="${pjEscapeHtml(image)}" alt="" loading="lazy">
        </span>
      `;
    }

    if (!icon) return "";

    if (isUrlValue(icon)) {
      return `
        <span class="pj-choice-badge__icon pj-choice-badge__icon--image" aria-hidden="true">
          <img src="${pjEscapeHtml(icon)}" alt="" loading="lazy">
        </span>
      `;
    }

    const normalizedIcon = icon.toLowerCase();

    const iconMap = {
      star: "★",
      heart: "♡",
      sparkle: "✦",
      diamond: "◆",
      circle: "●",
      dot: "•",
      plus: "+",
      truck: "🚚",
      gift: "🎁",
      fire: "🔥",
    };

    const iconContent = iconMap[normalizedIcon] || icon;

    return `
      <span class="pj-choice-badge__icon pj-choice-badge__icon--text" aria-hidden="true">
        ${pjEscapeHtml(iconContent)}
      </span>
    `;
  }

  function mountChoiceBadge(optionEl, badgeData) {
    const wrapper = optionEl.closest(".option") || optionEl.parentElement;
    if (!wrapper) return null;

    let badgeEl = getChoiceBadgeElement(wrapper, optionEl);

    if (!choiceBadgeHasContent(badgeData)) {
      badgeEl?.remove();

      setClassState(wrapper, "pj-choice-badge-wrapper", false);
      setClassState(wrapper, "pj-choice-badge-wrapper--below", false);
      setClassState(optionEl, "pj-choice-badge-host", false);

      return null;
    }

    const isBelow = badgeData.position === "below";

    setClassState(wrapper, "pj-choice-badge-wrapper", true);
    setClassState(wrapper, "pj-choice-badge-wrapper--below", isBelow);

    // important: below is still positioned relative to .cpb-option,
    // but visually placed outside the option border
    setClassState(optionEl, "pj-choice-badge-host", true);

    if (!badgeEl) {
      badgeEl = document.createElement("div");
      badgeEl.className = "pj-choice-badge";
    }

    Array.from(badgeEl.classList).forEach((className) => {
      if (className.startsWith("pj-choice-badge--")) {
        badgeEl.classList.remove(className);
      }
    });

    badgeEl.classList.add(`pj-choice-badge--${badgeData.position}`);

    setClassState(
      badgeEl,
      "pj-choice-badge--icon-only",
      !badgeData.text && !!(badgeData.icon || badgeData.image)
    );

    // All badge positions are mounted inside .cpb-option.
    // Corner badges stay inside border.
    // Below badge uses top: 100% in CSS, so it appears outside border.
    if (badgeEl.parentElement !== optionEl) {
      optionEl.appendChild(badgeEl);
    }

    const nextColor = badgeData.color || "";
    const currentColor = badgeEl.dataset.pjColor || "";

    if (currentColor !== nextColor) {
      badgeEl.dataset.pjColor = nextColor;

      if (nextColor) {
        badgeEl.style.setProperty("color", nextColor, "important");
      } else {
        badgeEl.style.removeProperty("color");
      }
    }

    const nextBackground = badgeData.background || "";
    const currentBackground = badgeEl.dataset.pjBackground || "";

    if (currentBackground !== nextBackground) {
      badgeEl.dataset.pjBackground = nextBackground;

      if (nextBackground) {
        badgeEl.style.setProperty(
          "background-color",
          nextBackground,
          "important"
        );
      } else {
        badgeEl.style.removeProperty("background-color");
      }
    }

    const contentChanged =
      badgeEl.dataset.pjText !== badgeData.text ||
      badgeEl.dataset.pjIcon !== badgeData.icon ||
      badgeEl.dataset.pjImage !== badgeData.image;

    if (contentChanged) {
      badgeEl.dataset.pjText = badgeData.text;
      badgeEl.dataset.pjIcon = badgeData.icon;
      badgeEl.dataset.pjImage = badgeData.image;

      badgeEl.innerHTML = `
        ${getChoiceBadgeIconHtml(badgeData.icon, badgeData.image)}
        ${
          badgeData.text
            ? `<span class="pj-choice-badge__text">${pjEscapeHtml(
                badgeData.text
              )}</span>`
            : ""
        }
      `;
    }

    return badgeEl;
  }

  function isOwnChoiceBadgeMutation(mutation) {
    const target = mutation.target;

    if (
      target?.nodeType === 1 &&
      typeof target.closest === "function" &&
      target.closest(".pj-choice-badge")
    ) {
      return true;
    }

    const changedNodes = [
      ...Array.from(mutation.addedNodes || []),
      ...Array.from(mutation.removedNodes || []),
    ];

    if (!changedNodes.length) return false;

    return changedNodes.every((node) => {
      if (node.nodeType !== 1) return false;

      return (
        node.classList?.contains("pj-choice-badge") ||
        (typeof node.closest === "function" && node.closest(".pj-choice-badge"))
      );
    });
  }

  function applyChoiceBadges() {
    const categories =
      CPB?.getStore?.().getState?.()?.Product?.panels?.[0]?.categories || [];

    if (!Array.isArray(categories) || categories.length === 0) return;

    const containersWithBadges = new Set();
    const containersWithBelowBadges = new Set();

    categories.forEach((category) => {
      const options = category?.options || [];
      if (!Array.isArray(options) || options.length === 0) return;

      options.forEach((option) => {
        const optionEl = getChoiceOptionElement(option?.id);
        if (!optionEl) return;

        const badgeData = getChoiceBadgeData(option);
        const badgeEl = mountChoiceBadge(optionEl, badgeData);

        const container = optionEl.closest(".cpb-category-options-container");

        if (badgeEl && container) {
          containersWithBadges.add(container);

          if (badgeData.position === "below") {
            containersWithBelowBadges.add(container);
          }
        }
      });
    });

    document
      .querySelectorAll("#product-builder .cpb-category-options-container")
      .forEach((container) => {
        setClassState(
          container,
          "pj-has-choice-badges",
          containersWithBadges.has(container)
        );

        setClassState(
          container,
          "pj-has-choice-badges-below",
          containersWithBelowBadges.has(container)
        );
      });
  }

  function initChoiceBadges() {
    if (window.__pjChoiceBadgesInited) return;
    window.__pjChoiceBadgesInited = true;

    let rafId = null;
    let timeoutOne = null;
    let timeoutTwo = null;

    const scheduleApply = () => {
      if (rafId) cancelAnimationFrame(rafId);
      clearTimeout(timeoutOne);
      clearTimeout(timeoutTwo);

      rafId = requestAnimationFrame(() => {
        applyChoiceBadges();

        timeoutOne = setTimeout(applyChoiceBadges, 300);
        timeoutTwo = setTimeout(applyChoiceBadges, 1000);
      });
    };

    scheduleApply();

    document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", scheduleApply);
    document.body.addEventListener(
      "PRODUCT_BUILDER_OPTION_ACTIVATE",
      scheduleApply
    );

    const root = document.querySelector("#product-builder");

    if (root) {
      const observer = new MutationObserver((mutations) => {
        const onlyOwnBadgeChanges = mutations.every(isOwnChoiceBadgeMutation);

        if (onlyOwnBadgeChanges) return;

        scheduleApply();
      });

      observer.observe(root, {
        childList: true,
        subtree: true,
      });

      window.__pjChoiceBadgesObserver = observer;
    }
  }

  function shouldHaveSelectedCheckmark(optionEl) {
    if (!optionEl) return false;

    const category = optionEl.closest(".cpb-category");
    if (!category) return false;

    // These are text selector categories without real boxed choices.
    // Example: Pump Type / Regular / Foaming.
    if (category.classList.contains("cpb-pump-type-option")) {
      return false;
    }

    const container = optionEl.closest(".cpb-category-options-container");
    if (!container) return false;

    const isTextBoxChoice =
      container.classList.contains("text") &&
      optionEl.classList.contains("cpb-option-type-text");

    const isImageBoxChoice =
      container.classList.contains("img") &&
      optionEl.classList.contains("cpb-option-type-img");

    const isColorBoxChoice =
      container.classList.contains("color") &&
      optionEl.classList.contains("cpb-option-type-color");

    return isTextBoxChoice || isImageBoxChoice || isColorBoxChoice;
  }

  function isChoiceOptionSelected(optionEl) {
    if (!optionEl) return false;

    const wrapper = optionEl.closest(".option");

    return (
      isChoiceOptionActive(optionEl) ||
      wrapper?.classList.contains("active") ||
      !!optionEl.querySelector(
        ".cpb-active, [aria-pressed='true'], [aria-selected='true'], [aria-checked='true']"
      )
    );
  }

  function getSelectedCheckmarkElement(optionEl) {
    if (!optionEl) return null;

    return Array.from(optionEl.children).find((child) =>
      child.classList?.contains("pj-selected-checkmark")
    );
  }

  function mountSelectedCheckmark(optionEl, isSelected) {
    if (!optionEl) return;

    let checkmarkEl = getSelectedCheckmarkElement(optionEl);

    if (!isSelected) {
      checkmarkEl?.remove();
      setClassState(optionEl, "pj-selected-checkmark-host", false);
      return;
    }

    setClassState(optionEl, "pj-selected-checkmark-host", true);

    if (!checkmarkEl) {
      checkmarkEl = document.createElement("div");
      checkmarkEl.className = "pj-selected-checkmark";
      checkmarkEl.setAttribute("aria-hidden", "true");
      checkmarkEl.textContent = "✓";

      optionEl.appendChild(checkmarkEl);
    }
  }

  function applySelectedCheckmarks() {
    const categories =
      CPB?.getStore?.().getState?.()?.Product?.panels?.[0]?.categories || [];

    if (!Array.isArray(categories) || categories.length === 0) return;

    const touchedOptions = new Set();

    categories.forEach((category) => {
      const options = category?.options || [];
      if (!Array.isArray(options) || options.length === 0) return;

      options.forEach((option) => {
        const optionEl = getChoiceOptionElement(option?.id);
        if (!optionEl) return;

        if (!shouldHaveSelectedCheckmark(optionEl)) {
          mountSelectedCheckmark(optionEl, false);
          return;
        }

        touchedOptions.add(optionEl);

        mountSelectedCheckmark(optionEl, isChoiceOptionSelected(optionEl));
      });
    });

    document
      .querySelectorAll("#product-builder .pj-selected-checkmark")
      .forEach((checkmarkEl) => {
        const optionEl = checkmarkEl.closest(".cpb-option");

        if (!optionEl || !touchedOptions.has(optionEl)) {
          checkmarkEl.remove();
        }
      });

    document
      .querySelectorAll(
        "#product-builder .cpb-option.pj-selected-checkmark-host"
      )
      .forEach((optionEl) => {
        if (!touchedOptions.has(optionEl)) {
          setClassState(optionEl, "pj-selected-checkmark-host", false);
        }
      });
  }

  function isOwnSelectedCheckmarkMutation(mutation) {
    const changedNodes = [
      ...Array.from(mutation.addedNodes || []),
      ...Array.from(mutation.removedNodes || []),
    ];

    if (!changedNodes.length) return false;

    return changedNodes.every((node) => {
      if (node.nodeType !== 1) return false;

      return (
        node.classList?.contains("pj-selected-checkmark") ||
        (typeof node.closest === "function" &&
          node.closest(".pj-selected-checkmark"))
      );
    });
  }

  function initSelectedCheckmarks() {
    if (window.__pjSelectedCheckmarksInited) return;
    window.__pjSelectedCheckmarksInited = true;

    let rafId = null;
    let timeoutOne = null;
    let timeoutTwo = null;

    const scheduleApply = () => {
      if (rafId) cancelAnimationFrame(rafId);
      clearTimeout(timeoutOne);
      clearTimeout(timeoutTwo);

      rafId = requestAnimationFrame(() => {
        applySelectedCheckmarks();

        timeoutOne = setTimeout(applySelectedCheckmarks, 250);
        timeoutTwo = setTimeout(applySelectedCheckmarks, 800);
      });
    };

    scheduleApply();

    document.addEventListener(
      "click",
      (event) => {
        if (event.target.closest("#product-builder .cpb-option")) {
          scheduleApply();
        }
      },
      true
    );

    document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", scheduleApply);
    document.body.addEventListener(
      "PRODUCT_BUILDER_OPTION_ACTIVATE",
      scheduleApply
    );

    const root = document.querySelector("#product-builder");

    if (root) {
      const observer = new MutationObserver((mutations) => {
        const onlyOwnCheckmarkChanges = mutations.every(
          isOwnSelectedCheckmarkMutation
        );

        if (onlyOwnCheckmarkChanges) return;

        scheduleApply();
      });

      observer.observe(root, {
        childList: true,
        subtree: true,
      });

      window.__pjSelectedCheckmarksObserver = observer;
    }
  }

  function initMobileInputPreviewRefresh() {
    if (window.__pjMobileInputPreviewRefreshInited) return;
    window.__pjMobileInputPreviewRefreshInited = true;

    const inputSelector = [
      "#product-builder textarea",
      "#product-builder input[type='text']",
      "#product-builder input:not([type])",
    ].join(",");

    const optionSelector = [
      "#product-builder .cpb-option[role='button']",
      "#product-builder .cpb-option.cpb-option-type-text",
      "#product-builder .cpb-option.cpb-option-type-img",
      "#product-builder .cpb-option.cpb-option-type-color",
    ].join(",");

    const isMobile = () => window.matchMedia("(max-width: 999px)").matches;

    let hadMobileTextInputFocus = false;
    let timers = [];

    function dispatchCpbRefreshEvents() {
      window.dispatchEvent(new Event("resize"));

      document.dispatchEvent(
        new Event("CPB_ON_OPTIONS_UPDATE", { bubbles: true })
      );

      document.body?.dispatchEvent(
        new Event("CPB_ON_OPTIONS_UPDATE", { bubbles: true })
      );

      document.dispatchEvent(
        new Event("CPB_ON_UPDATE_CURRENT_VIEW", { bubbles: true })
      );

      document.body?.dispatchEvent(
        new Event("CPB_ON_UPDATE_CURRENT_VIEW", { bubbles: true })
      );
    }

    function refreshSwipers() {
      document
        .querySelectorAll("#product-builder .swiper-container")
        .forEach((el) => {
          const swiper = el.swiper;
          if (!swiper) return;

          swiper.updateSize?.();
          swiper.updateSlides?.();
          swiper.update?.();
        });
    }

    function forcePreviewRefresh() {
      if (!isMobile()) return;

      timers.forEach(clearTimeout);
      timers = [];

      [0, 120, 350, 800, 1400].forEach((delay) => {
        timers.push(
          setTimeout(() => {
            dispatchCpbRefreshEvents();
            refreshSwipers();

            const preview = document.querySelector(
              "#product-builder .cpb-preview-container"
            );

            if (preview) {
              void preview.offsetHeight;
            }
          }, delay)
        );
      });
    }

    document.addEventListener(
      "focusin",
      (event) => {
        if (!isMobile()) return;
        if (!event.target.matches?.(inputSelector)) return;

        hadMobileTextInputFocus = true;
      },
      true
    );

    document.addEventListener(
      "focusout",
      (event) => {
        if (!isMobile()) return;
        if (!event.target.matches?.(inputSelector)) return;

        hadMobileTextInputFocus = true;
        forcePreviewRefresh();
      },
      true
    );

    document.addEventListener(
      "click",
      (event) => {
        if (!isMobile()) return;
        if (!hadMobileTextInputFocus) return;
        if (!event.target.closest?.(optionSelector)) return;

        forcePreviewRefresh();
        setTimeout(forcePreviewRefresh, 250);
      },
      true
    );

    if (window.visualViewport) {
      let viewportTimer = null;

      const onViewportChange = () => {
        if (!isMobile()) return;
        if (!hadMobileTextInputFocus) return;

        clearTimeout(viewportTimer);
        viewportTimer = setTimeout(forcePreviewRefresh, 250);
      };

      window.visualViewport.addEventListener("resize", onViewportChange);
      window.visualViewport.addEventListener("scroll", onViewportChange);
    }
  }

  function initPJMobileDebugPanel() {
    if (!/[?&]pjdebug=1\b/.test(window.location.search)) return;
    if (window.__pjMobileDebugPanelInited) return;
    window.__pjMobileDebugPanelInited = true;

    const panel = document.createElement("div");
    panel.style.cssText = `
      position: fixed;
      left: 8px;
      right: 8px;
      bottom: 8px;
      z-index: 999999;
      max-height: 38vh;
      overflow: auto;
      padding: 8px;
      background: rgba(0,0,0,.82);
      color: #00ff8a;
      font: 11px/1.35 monospace;
      white-space: pre-wrap;
      border-radius: 6px;
    `;

    document.body.appendChild(panel);

    const lines = [];

    function getCanvasInfo() {
      const canvases = Array.from(
        document.querySelectorAll("#product-builder canvas")
      );

      const konvaCanvases = Array.from(
        document.querySelectorAll("#product-builder .konvajs-content canvas")
      );

      const preview = document.querySelector(
        "#product-builder .cpb-preview-container"
      );
      const konva = document.querySelector("#product-builder .konvajs-content");

      if (!canvases.length) {
        return [
          `canvas: none`,
          `preview: ${preview ? "yes" : "no"}`,
          `konva: ${konva ? "yes" : "no"}`,
        ].join(" | ");
      }

      return canvases
        .map((canvas, index) => {
          const rect = canvas.getBoundingClientRect();

          return [
            `canvas #${index + 1}`,
            `attr: ${canvas.width}x${canvas.height}`,
            `css: ${Math.round(rect.width)}x${Math.round(rect.height)}`,
            `konva:${konvaCanvases.includes(canvas)}`,
            `dpr:${window.devicePixelRatio}`,
          ].join(" | ");
        })
        .join("\n");
    }

    function getViewportInfo() {
      const vv = window.visualViewport;

      return [
        `inner: ${window.innerWidth}x${window.innerHeight}`,
        vv
          ? `vv: ${Math.round(vv.width)}x${Math.round(vv.height)} scale:${
              vv.scale
            }`
          : "vv: none",
      ].join(" | ");
    }

    function findStoreOptionById(optionId) {
      const state = CPB?.getStore?.().getState?.();
      const categories = state?.Product?.panels?.[0]?.categories || [];

      for (const cat of categories) {
        const options = cat?.options || [];

        for (const opt of options) {
          if (opt?.id !== optionId) continue;

          const scalar = {};

          Object.keys(opt).forEach((key) => {
            const value = opt[key];

            if (
              value == null ||
              ["string", "number", "boolean"].includes(typeof value)
            ) {
              scalar[key] = value;
            }
          });

          return {
            category: cat.title || cat.name || cat.label || cat.id,
            option: opt.label || opt.name || opt.title || opt.id,
            scalar,
          };
        }
      }

      return null;
    }

    function getPreviewStructureInfo() {
      const preview = document.querySelector(
        "#product-builder .cpb-preview-container"
      );
      const sticky = document.querySelector(
        "#product-builder .cpb-preview-sticky"
      );
      const elements = document.querySelector(
        "#product-builder .cpb-preview-elements"
      );
      const mainSwiperEl = document.querySelector(
        "#product-builder .cpb-swiper-main .swiper-container"
      );
      const mainSwiper = mainSwiperEl?.swiper;

      const rectInfo = (label, el) => {
        if (!el) return `${label}: none`;

        const rect = el.getBoundingClientRect();
        const cs = window.getComputedStyle(el);

        return `${label}: ${Math.round(rect.width)}x${Math.round(
          rect.height
        )} display:${cs.display} visibility:${cs.visibility} opacity:${
          cs.opacity
        }`;
      };

      const canvases = Array.from(
        document.querySelectorAll("#product-builder canvas")
      ).map((canvas, i) => {
        const rect = canvas.getBoundingClientRect();
        const isKonva = !!canvas.closest(".konvajs-content");

        return `canvas#${i + 1}: attr:${canvas.width}x${
          canvas.height
        } css:${Math.round(rect.width)}x${Math.round(
          rect.height
        )} konva:${isKonva}`;
      });

      const imgs = Array.from(
        document.querySelectorAll("#product-builder .cpb-preview-container img")
      ).map((img, i) => {
        const rect = img.getBoundingClientRect();

        return `img#${i + 1}: css:${Math.round(rect.width)}x${Math.round(
          rect.height
        )} src:${(img.currentSrc || img.src || "").slice(0, 80)}`;
      });

      return [
        rectInfo("preview", preview),
        rectInfo("sticky", sticky),
        rectInfo("elements", elements),
        `swiper: ${
          mainSwiper
            ? `active:${mainSwiper.activeIndex} slides:${mainSwiper.slides?.length} translate:${mainSwiper.translate}`
            : "none"
        }`,
        canvases.length ? canvases.join("\n") : "canvas: none",
        imgs.length ? imgs.join("\n") : "preview img: none",
      ].join("\n");
    }

    function log(label) {
      const time = new Date().toLocaleTimeString();

      lines.unshift(
        `${time} ${label}\n${getViewportInfo()}\n${getCanvasInfo()}`
      );

      if (lines.length > 24) lines.pop();

      panel.textContent = lines.join("\n\n");
    }

    log("debug started");

    document.addEventListener(
      "click",
      (event) => {
        const option = event.target.closest("#product-builder .cpb-option");
        if (!option) return;

        log(
          `option click: ${
            option.dataset.optionId || "no id"
          } active:${option.classList.contains(
            "cpb-active"
          )} aria:${option.getAttribute("aria-pressed")}`
        );

        setTimeout(() => log("after click 300ms"), 300);
        setTimeout(() => log("after click 1000ms"), 1000);
      },
      true
    );

    document.addEventListener(
      "click",
      (event) => {
        const target = event.target;
        const option = target.closest?.("#product-builder .cpb-option");

        const x = event.clientX;
        const y = event.clientY;
        const fromPoint = document.elementFromPoint(x, y);

        const optionId = option?.dataset?.optionId || "";
        const storeOption = optionId ? findStoreOptionById(optionId) : null;

        log(
          [
            "document click",
            `target: ${target?.tagName || "none"} .${target?.className || ""}`,
            `option: ${optionId || "no"}`,
            `dom active before: ${option?.classList?.contains(
              "cpb-active"
            )} aria:${option?.getAttribute?.("aria-pressed")}`,
            `point: ${Math.round(x)},${Math.round(y)}`,
            `fromPoint: ${fromPoint?.tagName || "none"} .${
              fromPoint?.className || ""
            }`,
            `store before: ${
              storeOption ? JSON.stringify(storeOption).slice(0, 500) : "none"
            }`,
            getPreviewStructureInfo(),
          ].join("\n")
        );

        setTimeout(() => {
          const storeAfter = optionId ? findStoreOptionById(optionId) : null;

          log(
            [
              "after click 500ms",
              `option: ${optionId || "no"}`,
              `dom active after: ${option?.classList?.contains(
                "cpb-active"
              )} aria:${option?.getAttribute?.("aria-pressed")}`,
              `store after: ${
                storeAfter ? JSON.stringify(storeAfter).slice(0, 500) : "none"
              }`,
              getPreviewStructureInfo(),
            ].join("\n")
          );
        }, 500);
      },
      true
    );

    document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", () => {
      log("CPB_ON_OPTIONS_UPDATE");
    });

    document.body.addEventListener("PRODUCT_BUILDER_OPTION_ACTIVATE", () => {
      log("PRODUCT_BUILDER_OPTION_ACTIVATE");
    });

    if (window.visualViewport) {
      // window.visualViewport.addEventListener("resize", () => log("visualViewport resize"));
      // window.visualViewport.addEventListener("scroll", () => log("visualViewport scroll"));
    }

    window.addEventListener("resize", () => log("window resize"));
  }

  function init() {
    const customAddToCart = new CustomAddToCart();
    changeLoaderImage.init();
    hideTooltipOnScroll();
    observeBrokenAria();
    initCategoryMetaStyles();
    initChoiceLabels();
    initChoicePopups();
    initChoiceBadges();
    initSelectedCheckmarks();
    initMobileInputPreviewRefresh();
    initPJMobileDebugPanel();
    // duscounts()
    myRegistry(customAddToCart);

    PJSteps.init();
  }

  function hideTooltipOnScroll() {
    setScrollOnce();

    function setScrollOnce() {
      document.addEventListener(
        "scroll",
        function () {
          hideActiveTooltip();
          setTimeout(setScrollOnce, 1000);
        },
        { once: true }
      );
    }

    function hideActiveTooltip() {
      const tooltip = document.querySelector(".Polaris-PositionedOverlay");
      if (!tooltip) return;
      tooltip.style.display = "none";
    }
  }

  const PJThumbsVisualAlign = (() => {
    const THUMBS_SELECTOR = ".cpb-swiper-thumbnails .swiper-container";

    const boundSwipers = new WeakSet();

    let rafId = null;
    let timeoutOne = null;
    let timeoutTwo = null;
    let timeoutThree = null;
    let observer = null;
    let isGlobalEventsBound = false;

    const clamp = (value, min, max) => {
      return Math.max(min, Math.min(max, value));
    };

    const getNumberCssVar = (element, name, fallback) => {
      const value = window.getComputedStyle(element).getPropertyValue(name);
      const parsed = parseFloat(value);

      return Number.isFinite(parsed) ? parsed : fallback;
    };

    const getThumbsSwiper = () => {
      return document.querySelector(THUMBS_SELECTOR)?.swiper || null;
    };

    const bindSwiperEvents = (swiper) => {
      if (
        !swiper ||
        boundSwipers.has(swiper) ||
        typeof swiper.on !== "function"
      ) {
        return;
      }

      boundSwipers.add(swiper);

      swiper.on("slideChange", scheduleAlign);
      swiper.on("transitionEnd", scheduleAlign);
      swiper.on("slideChangeTransitionEnd", scheduleAlign);
    };

    const align = () => {
      const swiper = getThumbsSwiper();

      if (
        !swiper ||
        !swiper.el ||
        !swiper.wrapperEl ||
        !swiper.slides?.length
      ) {
        return;
      }

      bindSwiperEvents(swiper);

      const thumbsRoot =
        swiper.el.closest(".cpb-swiper-thumbnails") || swiper.el;
      const wrapper = swiper.wrapperEl;
      const slides = Array.from(swiper.slides);

      const activeSlideFromClass = wrapper.querySelector(
        ".swiper-slide-active"
      );
      const activeIndexFromClass = slides.indexOf(activeSlideFromClass);

      const activeIndex = clamp(
        activeIndexFromClass >= 0
          ? activeIndexFromClass
          : swiper.activeIndex || 0,
        0,
        slides.length - 1
      );

      const activeSlide = slides[activeIndex];
      const firstSlide = slides[0];
      const lastSlide = slides[slides.length - 1];

      const containerWidth = swiper.el.clientWidth;
      const currentTranslate = swiper.translate || 0;

      const leftOffset = getNumberCssVar(
        thumbsRoot,
        "--pj-thumbs-left-offset",
        44
      );

      const rightOffset = getNumberCssVar(
        thumbsRoot,
        "--pj-thumbs-right-offset",
        44
      );

      const activeLeft = activeSlide.offsetLeft + currentTranslate;
      const firstLeft = firstSlide.offsetLeft + currentTranslate;
      const lastRight =
        lastSlide.offsetLeft + lastSlide.offsetWidth + currentTranslate;

      /**
       * Usually: active thumbnail starts near the left side,
       * but with a small offset so it does not overlap the left arrow.
       */
      let shift = leftOffset - activeLeft;

      /**
       * Near the true end: do not create empty space on the right.
       * This keeps the last thumbnail near the right side, not centered.
       */
      const minShiftToFillRightSide = containerWidth - rightOffset - lastRight;

      /**
       * Near the true beginning: do not create empty space on the left.
       */
      const maxShiftToFillLeftSide = leftOffset - firstLeft;

      shift = clamp(shift, minShiftToFillRightSide, maxShiftToFillLeftSide);

      wrapper.classList.add("pj-thumbs-visual-align");
      wrapper.style.setProperty("--pj-thumbs-shift", `${shift}px`);
    };

    function scheduleAlign() {
      cancelAnimationFrame(rafId);
      clearTimeout(timeoutOne);
      clearTimeout(timeoutTwo);
      clearTimeout(timeoutThree);

      rafId = requestAnimationFrame(align);

      /**
       * CPB/Swiper sometimes update activeIndex/translate asynchronously.
       * These delayed calls keep the visual correction stable after arrows,
       * thumbnail clicks, option changes, and preview re-renders.
       */
      timeoutOne = setTimeout(align, 80);
      timeoutTwo = setTimeout(align, 250);
      timeoutThree = setTimeout(align, 550);
    }

    const bindGlobalEvents = () => {
      if (isGlobalEventsBound) return;

      isGlobalEventsBound = true;

      document.addEventListener(
        "click",
        (event) => {
          const isArrowClick = event.target.closest(".cpb-preview-arrows-item");
          const isThumbnailClick = event.target.closest(
            ".cpb-swiper-thumbnails .swiper-slide"
          );

          if (isArrowClick || isThumbnailClick) {
            scheduleAlign();
          }
        },
        true
      );

      document.addEventListener("CPB_ON_PRODUCT_MOUNTED", scheduleAlign);
      document.addEventListener("CPB_ON_OPTIONS_UPDATE", scheduleAlign);

      window.addEventListener("resize", scheduleAlign);
      window.addEventListener("load", scheduleAlign);
    };

    const initObserver = () => {
      if (observer) return;

      const root = document.querySelector("#product-builder") || document.body;

      observer = new MutationObserver(() => {
        scheduleAlign();
      });

      observer.observe(root, {
        childList: true,
        subtree: true,
      });
    };

    const init = () => {
      bindGlobalEvents();
      initObserver();
      scheduleAlign();
    };

    return {
      init,
      align,
    };
  })();

  document.addEventListener("CPB_ON_PRODUCT_MOUNTED", () => {
    PJThumbsVisualAlign.init();
  });

  window.addEventListener("load", () => {
    PJThumbsVisualAlign.init();
  });

  setTimeout(() => {
    PJThumbsVisualAlign.init();
  }, 500);
})(jQuery);
